import { apiRequest } from "../util/apiUtils";

export const authLogin = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      payload?.type === "user"
        ? `login`
        : payload?.type === "admin" && "admin-login",
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const authSignup = async (payload) => {
  try {
    const res = await apiRequest("post", "signup", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const otpVerification = async (payload) => {
  try {
    const res = await apiRequest("post", "verify-otp", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const forgetPassword = async (payload) => {
  try {
    const res = await apiRequest("post", "user/forget-password", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const verifyAuthToken = async (payload) => {
  try {
    const res = await apiRequest("post", `verify-token`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const tokenRefresh = async (payload) => {
  try {
    const res = await apiRequest("post", `refresh-token`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const resetPasswordRequest = async (payload) => {
  try {
    const res = await apiRequest("post", "user/reset-cred", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const sendOtp = async (payload) => {
  try {
    const res = await apiRequest("post", "send-otp", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const resetPasswordAccept = async (payload) => {
  try {
    const res = await apiRequest("post", "user/accept-reset-status", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const setPassword = async (payload) => {
  try {
    const res = await apiRequest("post", "set-password", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
